<template>
  <i class="arrow-down-icon inline-block pointer"
     @click="handleClick">
    <svg width="28" height="15" viewBox="0 0 28 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L14 14L27 1" stroke="black"/>
    </svg>
  </i>
</template>

<script>
  export default {
    name: 'ArrowDownIcon',
    methods: {
      handleClick (ev) {
        this.$emit('click', ev);
      }
    }
  }
</script>

<style lang="less">
  .arrow-down-icon {
    @media only screen and (min-width: 0) {
      transition: transform 0.1s ease-in-out;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
</style>
